"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageEnum = void 0;
var HomePageEnum;
(function (HomePageEnum) {
    HomePageEnum["DEFAULT"] = "default";
})(HomePageEnum || (exports.HomePageEnum = HomePageEnum = {}));
